import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Bookmark from '@alltrails/denali/icons/Bookmark';
import BookmarkFilled from '@alltrails/denali/icons/BookmarkFilled';
import styles from './TopResults.module.scss';

type Props = {
  isFavorite: boolean;
  onClick: () => void;
};

const BookmarkButtonWrapper = ({ isFavorite, onClick }: Props) => {
  const intl = useIntl();

  return (
    <IconButton
      className={styles.trailCardSnippetBookmark}
      icon={isFavorite ? { Component: BookmarkFilled } : { Component: Bookmark }}
      onClick={onClick}
      title={intl.formatMessage({ defaultMessage: 'Add to list' })}
      testId="location-page-bookmark"
      size="sm"
    />
  );
};

export default BookmarkButtonWrapper;
